import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import analytics, * as trackingTypes from '../../actions/analyticsActions';

import VideoComponent from './VideoComponent';

export class VideoCollection extends React.Component {
    static propTypes = {
        disabled: PropTypes.bool,
        dispatch: PropTypes.func.isRequired,
        videos: PropTypes.array,
    };

    static defaultProps = {
        videos: [],
    };

    trackVideoStatus = (source, status) =>
        this.props.dispatch(
            analytics(trackingTypes.VIDEO_STATUS, { source, status })
        );

    renderDual() {
        const videos = this.props.videos.map((video) => (
            <div className="grid__unit" key={video.id}>
                <div className="panel">
                    <VideoComponent
                        description={video.description}
                        dimensions={{ h: 252, w: 448 }}
                        disabled={this.props.disabled}
                        onStatusChange={this.trackVideoStatus}
                        videoUrl={video.href}
                    />
                </div>
            </div>
        ));

        return <div className="grid t-grid grid--cols1to2">{videos}</div>;
    }

    renderSingle() {
        const video = this.props.videos[0];

        return (
            <div className="grid t-grid grid--cols1to2">
                <div className="grid__unit">
                    <div className="panel">
                        <VideoComponent
                            dimensions={{ h: 252, w: 448 }}
                            disabled={this.props.disabled}
                            onStatusChange={this.trackVideoStatus}
                            videoUrl={video.href}
                        />
                    </div>
                </div>
                <div className="grid__unit">
                    <div className="panel">
                        <div style={{ cursor: 'default' }}>
                            <p className="u-t3">{video.description}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { videos } = this.props;

        if (!videos || videos.length === 0) return null;

        return (
            <section>
                {videos.length === 1 ? this.renderSingle() : this.renderDual()}
            </section>
        );
    }
}

export default connect(() => ({}))(VideoCollection);
